import { useNavigate, useParams } from "@/router";
import { useEffect } from "react";
import { usePersonEducationCapability } from "../person/_usePersonEducationAccess";

export default function EducationIndex() {
  const { pgaId } = useParams("/people/:pgaId/education");
  const navigate = useNavigate();
  const { loaded, canViewPersonEducation } = usePersonEducationCapability();

  useEffect(() => {
    if (!loaded) return;
    if (!canViewPersonEducation) {
      navigate("/people/:pgaId/person/overview", { params: { pgaId }, replace: true });
      return;
    }
    navigate("/people/:pgaId/education/professional-development", { params: { pgaId }, replace: true });
  }, [canViewPersonEducation, loaded, navigate, pgaId]);

  return null;
}
